export default function XSD_DateTime() {
  return (
    <div>
      <h1>XSD_DateTime</h1>
      <p>This is the XSD_DateTime component.</p>
    </div>
  );
}